"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ButtonTab = require("./ButtonTab");
Object.keys(_ButtonTab).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ButtonTab[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ButtonTab[key];
    }
  });
});